import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import * as reducks from '../../../reducks'

const Authenticate = (props) => {
  const { children } = props

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(reducks.resources.session.actions.authenticate())
  }, [])

  return <>{children}</>
}

Authenticate.defaultProps = {
  children: null
}

Authenticate.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node])
}

export default Authenticate
